import { motion } from "framer-motion";
import { MonitorSmartphone, ShieldCheck, Rocket, CloudCog, ArrowUpRight } from "lucide-react";
import { useLang } from "@/lib/i18n";

const META = [
  { id: "intune", icon: MonitorSmartphone },
  { id: "defender", icon: ShieldCheck },
  { id: "autopilot", icon: Rocket },
  { id: "cloud", icon: CloudCog },
];

export default function Services() {
  const { t } = useLang();
  const SERVICES = t("services.items").map((s, i) => ({ ...META[i], ...s }));
  return (
    <section id="services" data-testid="services-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-end justify-between mb-14 flex-wrap gap-6">
          <div>
            <p className="font-mono text-xs tracking-[0.25em] uppercase text-primary mb-4">{t("services.overline")}</p>
            <h2 className="font-heading font-bold tracking-tight leading-none text-4xl sm:text-5xl lg:text-6xl">
              {t("services.h1")}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {SERVICES.map((s, i) => (
            <motion.article
              key={s.id}
              data-testid={`service-card-${s.id}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="group bg-white border border-black p-7 flex flex-col hover:border-accent hover:-translate-y-1 transition-[border-color,transform] duration-300"
            >
              <div className="flex items-start justify-between mb-10">
                <span className="w-11 h-11 flex items-center justify-center border border-black text-primary group-hover:bg-primary group-hover:text-background transition-colors duration-300">
                  <s.icon className="w-5 h-5" strokeWidth={1.75} />
                </span>
                <span className="font-mono text-xs text-muted-foreground">0{i + 1}</span>
              </div>
              <h3 className="font-heading font-bold text-xl tracking-tight mb-3 flex items-center gap-2">
                {s.title}
                <ArrowUpRight className="w-4 h-4 opacity-0 -translate-x-1 translate-y-1 group-hover:opacity-100 group-hover:translate-x-0 group-hover:translate-y-0 text-primary transition-[opacity,transform] duration-300" />
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed flex-1">{s.desc}</p>
              <div className="flex flex-wrap gap-2 mt-6">
                {s.tags.map((t) => (
                  <span key={t} className="font-mono text-[10px] tracking-widest uppercase px-2.5 py-1 bg-black/[0.04] text-foreground border border-black/15">
                    {t}
                  </span>
                ))}
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
